import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3a807ec0")
const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-m-0" }, "Categorías de Producto", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No hay Categorías todavía. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cargando... ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check p-mr-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Si ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times p-mr-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "new-category-key" }, "Key", -1)
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "new-category-name" }, "Nombre", -1)
const _hoisted_18 = { class: "p-field" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "new-category-key" }, "Descripcion", -1)
const _hoisted_20 = { class: "p-field-checkbox" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Habilitada")
const _hoisted_22 = { class: "p-field" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Label = _resolveComponent("Label")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.categories,
      paginator: false,
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      globalFilterFields: ['name', 'state'],
      filters: _ctx.filters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters = $event)),
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus-circle",
              label: "Agregar Categoría",
              class: "p-button-rounded p-button-text p-ml-1 p-button-success",
              onClick: _ctx.addNew
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      loading: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Nombre",
          sortable: "",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "Key",
          sortable: "",
          field: "key"
        }),
        _createVNode(_component_Column, {
          header: "Habilitada",
          sortable: "",
          field: "enable"
        }, {
          body: _withCtx(({ data }) => [
            (data?.enable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_8))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_12))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          headerStyle: "width: 8rem; text-align: center",
          bodyStyle: "text-align: center; overflow: visible"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-trash",
              onClick: ($event: any) => (_ctx.onDelete(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: ($event: any) => (_ctx.onEdit(data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters"]),
    _createVNode(_component_Dialog, {
      header: `${_ctx.editingCategory.key ? 'Editar' : 'Nueva'} Categoría`,
      visible: _ctx.showEditDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showEditDialog = $event)),
      style: { 'max-width': '95vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_InputText, {
              id: "new-category-key",
              modelValue: _ctx.editingCategory.key,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editingCategory.key = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_InputText, {
              id: "new-category-name",
              modelValue: _ctx.editingCategory.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingCategory.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_Textarea, {
              id: "new-category-key",
              modelValue: _ctx.editingCategory.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editingCategory.description = $event)),
              autoResize: true,
              rows: "2",
              cols: "30"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Checkbox, {
              binary: true,
              id: "enable-checkbox",
              name: "enable",
              modelValue: _ctx.editingCategory.enable,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editingCategory.enable = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Label, {
              class: "p-ml-2",
              for: "enable-checkbox"
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Button, {
              label: "Guardar",
              icon: "pi pi-check",
              onClick: _ctx.onSaveCategory,
              disabled: !_ctx.isValidCategoryData
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ]))
}